import axios from "axios";
import { useState, useEffect } from "react";
import { API_REGION_VERSION_MAP } from "../utils";

const removeHyphen = (hyphenatedLocale: string) => {
  const region = hyphenatedLocale.split("-")[1].toUpperCase();
  return hyphenatedLocale.split("-")[0] + region;
};

export const useRemoveMember = (
  UID: string | undefined,
  groupId: string | undefined,
) => {
  const [removeMemberError, setRemoveMemberError] = useState(false);
  const [loadingRemoveMember, setLoadingRemoveMember] = useState(true);
  const [removedMemberInfo, setRemovedMemberInfo] = useState({
    emailId: "",
    groupId: "",
  });
  const [removeMemberResp, setRemoveMemberResp] = useState();
  const apiVersion =
    API_REGION_VERSION_MAP[removeHyphen(process.env.REACT_APP_LOCALE!)];

  useEffect(() => {
    // REMOVE SOMEONE ELSE
    if (UID && removedMemberInfo.emailId && removedMemberInfo.groupId) {
      window.gigya.accounts.getJWT({
        UID,
        callback: (resp) => {
          if (resp["errorCode"] === 0) {
            const headers = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${resp.id_token}`,
            };
            const apiKey = process.env.REACT_APP_CDC_API_KEY ?? "";
            const RemoveMemberUrl = `${process.env.REACT_APP_CDC_API_BASEURL}/${process.env.REACT_APP_CDC_API_VERSION}/cdc/groups/removeMember`;
            const RemoveMemberUrlTW = `${process.env.REACT_APP_CDC_API_BASEURL}/${apiVersion}/cdc/groups/removeMember`;
            axios
              .post(
                process.env.REACT_APP_LOCALE !== "en-us"
                  ? RemoveMemberUrlTW
                  : RemoveMemberUrl,
                {
                  apiKey,
                  groupId: removedMemberInfo.groupId,
                  emailId: removedMemberInfo.emailId,
                },
                { headers },
              )
              .then((res) => {
                setRemoveMemberResp(res.data);
                setLoadingRemoveMember(false);
                setRemoveMemberError(false);
              })
              .catch((error) => {
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log("Error Data: ", error.response.data);
                  console.log("Erorr Status: ", error.response.status);
                  console.log("Error Headers: ", error.response.headers);
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log(
                    "There was an error with your request: ",
                    error.request,
                  );
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log("Error: ", error.message);
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                }
                console.log("Error config: ", error.config);
                setRemoveMemberResp(undefined);
                setRemovedMemberInfo({ emailId: "", groupId: "" });
                setLoadingRemoveMember(true);
                setRemoveMemberError(true);
              });
          }
        },
      });
    }

    // REMOVE SELF
    if (UID && !removedMemberInfo.emailId && removedMemberInfo.groupId) {
      window.gigya.accounts.getJWT({
        UID,
        callback: (resp) => {
          if (resp["errorCode"] === 0) {
            const headers = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${resp.id_token}`,
            };
            const apiKey = process.env.REACT_APP_CDC_API_KEY ?? "";
            const RemoveMemberUrl = `${process.env.REACT_APP_CDC_API_BASEURL}/${process.env.REACT_APP_CDC_API_VERSION}/cdc/groups/removeMember`;
            const RemoveMemberUrlTW = `${process.env.REACT_APP_CDC_API_BASEURL}/${apiVersion}/cdc/groups/removeMember`;
            axios
              .post(
                process.env.REACT_APP_LOCALE !== "en-us"
                  ? RemoveMemberUrlTW
                  : RemoveMemberUrl,
                {
                  apiKey,
                  groupId: removedMemberInfo.groupId,
                },
                { headers },
              )
              .then((res) => {
                setRemoveMemberResp(res.data);
                setLoadingRemoveMember(false);
                setRemoveMemberError(false);
              })
              .catch((error) => {
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.log("Error Data: ", error.response.data);
                  console.log("Erorr Status: ", error.response.status);
                  console.log("Error Headers: ", error.response.headers);
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.log(
                    "There was an error with your request: ",
                    error.request,
                  );
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log("Error: ", error.message);
                  setRemoveMemberResp(undefined);
                  setRemovedMemberInfo({ emailId: "", groupId: "" });
                  setLoadingRemoveMember(true);
                  setRemoveMemberError(true);
                }
                console.log("Error config: ", error.config);
                setRemoveMemberResp(undefined);
                setRemovedMemberInfo({ emailId: "", groupId: "" });
                setLoadingRemoveMember(true);
                setRemoveMemberError(true);
              });
          }
        },
      });
    }

    return () => {
      setRemovedMemberInfo({ emailId: "", groupId: "" });
      setLoadingRemoveMember(true);
      setRemoveMemberError(false);
    };
  }, [removedMemberInfo.emailId, removedMemberInfo.groupId]);

  return {
    removeMemberResp,
    setRemovedMemberInfo,
    loadingRemoveMember,
    removeMemberError,
  };
};
